/** Barrel Export Pattern for Development-Only Components
 * Implements a "barrel export" pattern to conditionally load components
 * based on build env.
 *
 * Components exported through this file are only included in development.
 *
 * @example Use in any react component:
 * // n.b. Import syntax is the same for dev and prod
 * import { PropViewer } from 'components/Utilities'
 *
 * // Dynamically returns component (dev) and null (prod)
 * const AccountsContainer = (props) => {
 *   return (
 *     <>
 *       <h1>Accounts Container</h1>
 *       <PropViewer props={props} label="AccountsContainer Props" />
 *     </>
 *   )
 * }
 */

let PropViewer = null

// When not 'development' env, require('./PropViewer') never executes
// and PropViewer.jsx is excluded from the prod bundle.
if(process.env.NODE_ENV === 'development') {
  PropViewer = require('./PropViewer').default
} else {
  // In prod (including stage), PropViewer is a fn that returns null.
  PropViewer = () => null // eslint-disable-line react/display-name
}

// Uncomment block below for build-time info debugging
//   in browser console using: console.log(window.__PROPVIEWER_BUILD_INFO__)
// if(typeof window !== 'undefined') {
//   window.__PROPVIEWER_BUILD_INFO__ = {
//     nodeEnv:          process.env.NODE_ENV,
//     isRealComponent:  PropViewer.toString().includes('useState'),
//     bundleSize:       PropViewer.toString().length
//   }
// }

export { PropViewer }